
define('modules/application/wizard/steps/zoneStep/complexZoneStep/audioVideoZoneStep/zoneMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../zoneMenuView"
],

function(
  app,
  Backbone,
  jQueryUi,
  zoneMenuView) {

  var audioVideoZoneMenuView = zoneMenuView.extend({
    template  : "application/wizard/steps/zones/complexZones/audioVideoZones/menu-item",
    initialize: function() {
      zoneMenuView.prototype.initialize.apply(this);

      this.model.bind("render:requested", this.render, this);
    }
  });

  //Creating final audioVideoZoneMenuView class
  audioVideoZoneMenuView.extend({
    objClass      : "complexZonesMenuView"
  });

  // Required, return the module for AMD compliance
  return audioVideoZoneMenuView;

});